import { createFormStageContext } from 'BreetHelpers';

import type { WITHDRAWREQUESTUSDSTAGETYPE } from '../DialogWithdrawUsdRequest.helpers';

export const {
	ContextComponent: WithdrawRequestUsdFormStageContext,
	useFormStageContext: useWithdrawRequestUsdFormStageContext,
} = createFormStageContext<WITHDRAWREQUESTUSDSTAGETYPE>();
